export default "__VITE_ASSET___1iivv7m__"